import axios from 'axios'
import router from '../router/index.js'; 
//axios的一次封装
const service = axios.create({
  headers: {
    "Content-Type": "application/json;charset:utf-8;"
  },
  timeout: 300000,
})

const baseUrl_http =  'https://api.cngrain.com'
// const baseUrl_http =  'http://localhost:8881'

//请求拦截器
service.interceptors.request.use(  config => {
    config.url = baseUrl_http + config.url
    config.headers = {
        'type': "Web",
    }
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // token过期
    if (res.code === 3006) {
      if (localStorage.getItem("token")) {
        localStorage.clear();
        // this.$router.push('/') 
      }
    }
    // 未登录
    if (res.code === 3000) {
      // console.log('响应拦截，未登录',this.$router);
      // this.$router.push('/login');
      // router.push({ path: '/login' });
      router.replace('/login');

    }
    // 用户不存在
    if(res.code === 3005) {
      if (localStorage.getItem("token")) {
        localStorage.clear();
        router.push('/') 
      }
    }
    return response
  },

  error => {
    return Promise.reject(error)
  }
)

export default service